import {Link, NavLink} from '@remix-run/react'

import {Button} from '#app/ui/button'
import {LibraryBig} from '#app/ui/icons'
import {LinkButton} from '#app/ui/link-button'
import {ProviderConnectionForm} from '#app/utils/connections'
import {cn} from '#app/utils/misc'
import {isAdmin, useOptionalUser, userHasPermission, userHasRole} from '#app/utils/user'
import {Role} from '#types'

export function Header() {
  const user = useOptionalUser()

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background">
      <nav className="container">
        <div className="flex items-center gap-8">
          <Link
            className="flex items-center gap-1 text-nowrap border-b-2 border-transparent py-4 text-sm font-bold"
            to="/"
          >
            <LibraryBig className="h-5 w-5" />
            {ENV.APP_NAME}
          </Link>

          {user ? (
            <div className="flex items-center gap-6 text-sm">
              {[
                {to: '/books', label: 'Books'},
                {to: '/proposals', label: 'Proposals'},
                userHasPermission(user, 'read:rental') && {
                  to: '/rentals',
                  label: 'Rentals',
                },
                (userHasRole(user, Role.Librarian) || userHasRole(user, Role.Admin)) && {
                  to: '/settings',
                  label: 'Settings',
                },
                // userHasRole(user, Role.Supplier) && {
                //   to: '/books-to-order',
                //   label: 'Books to Order',
                // },
                isAdmin(user) && {
                  to: '/admin/users',
                  label: 'Users',
                },
                process.env.NODE_ENV === 'development' && {
                  to: '/devtools',
                  label: 'DevTools',
                },
              ]
                .filter(Boolean)
                .map(({to, label}) => (
                  <NavLink
                    className={({isActive}) =>
                      cn(
                        'border-b-2 border-transparent px-4 py-4 font-medium',
                        isActive && 'border-primary text-primary',
                      )
                    }
                    key={to}
                    to={to}
                  >
                    {label}
                  </NavLink>
                ))}
            </div>
          ) : null}

          <div className="ml-auto flex items-center gap-2">
            {user ? (
              <>
                <LinkButton to="/feedback" variant="ghost">
                  Feedback
                </LinkButton>
                <form action="/logout" method="post">
                  <Button type="submit" variant="outline">
                    Logout
                  </Button>
                </form>
              </>
            ) : (
              <ProviderConnectionForm
                providerName="microsoft"
                buttonProps={{children: 'Login', variant: 'outline'}}
              />
            )}
          </div>
        </div>
      </nav>
    </header>
  )
}
